'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  '3d': '3D',
  'access-accessibility': 'アクセスアクセシビリティ',
  'access-ad': 'アクセスAD',
  'access-assist-listening': 'アクセス聴覚支援',
  'access-braille': 'アクセス点字',
  'access-sign': 'アクセスサイン',
  'access-tty': 'アクセスtty',
  'access-volume-control': 'アクセスボリューム制御',
  'access-wheelchair-active': 'アクセス車椅子アクティブ',
  'access-wheelchair': 'アクセス車椅子',
  'achievement': '達成',
  'action': 'アクション',
  'actions': 'アクション',
  'add-circle': '追加円',
  'add': '追加',
  'aggregate': '集計',
  'aid': '補助',
  'alarm': 'アラーム',
  'alert': 'アラート',
  'analytics': '分析',
  'announce': 'アナウンス',
  'apps': 'アプリ',
  'archive': 'アーカイブ',
  'article': '記事',
  'ascend': '昇順',
  'attachment': '添付ファイル',
  'back-ten': '10戻る',
  'bar-chart': '棒グラフ',
  'basket': 'バスケット',
  'blog': 'ブログ',
  'book': '書籍',
  'bookmark': 'ブックマーク',
  'bottom-corner': '下部コーナー',
  'brand-apple-app-store': 'ブランドApple App Store',
  'brand-codepen-edit': 'ブランドCodepen編集',
  'brand-codepen-try': 'ブランドCodepen試行',
  'brand-google-play': 'ブランドGoogle Play',
  'brand-grommet-outline': 'ブランドGrommetアウトライン',
  'brand-grommet-path': 'ブランドGrommetパス',
  'brand-hpe-element-outline': 'ブランドHPEエレメントアウトライン',
  'brand-hpe-element-path': 'ブランドHPEエレメントパス',
  'brand-hpe-labs-insignia-outline': 'ブランドHPEラボ記章アウトライン',
  'brand-hpe-labs-insignia': 'ブランドHPEラボ記章',
  'brand-hpe-stack-centered': 'ブランドHPEスタック中央揃え',
  'brand-hpe-stack': 'ブランドHPEスタック',
  'briefcase': 'ブリーフケース',
  'brush': 'ブラシ',
  'bug': 'バグ',
  'bundle': 'バンドル',
  'business-service': 'ビジネスサービス',
  'calculator': '計算機',
  'calendar': 'カレンダー',
  'camera': 'カメラ',
  'capacity': '容量',
  'car': '車',
  'caret-down': 'キャレット下へ',
  'caret-next': 'キャレット次へ',
  'caret-previous': 'キャレット前へ',
  'caret-up': 'キャレット上へ',
  'cart': 'カート',
  'catalog': 'カタログ',
  'chapter-add': 'チャプター追加',
  'chapter-next': 'チャプター次へ',
  'chapter-previous': 'チャプター前へ',
  'chat': 'チャット',
  'checkbox-selected': 'チェックボックスオン',
  'checkbox': 'チェックボックス',
  'checkmark': 'チェックマーク',
  'circle-information': '円情報',
  'circle-play': '円再生',
  'circle-question': '円質問',
  'clear-option': 'クリアオプション',
  'clear': 'クリア',
  'CLI': 'CLI',
  'clipboard': 'クリップボード',
  'clock': 'クロック',
  'clone': '複製',
  'close': '閉じる',
  'closed-caption': 'クローズドキャプション',
  'cloud-computer': 'クラウドコンピューター',
  'cloud-download': 'クラウドダウンロード',
  'cloud-software': 'クラウドソフトウェア',
  'cloud-upload': 'クラウドアップロード',
  'cloud': 'クラウド',
  'cluster': 'クラスター',
  'code': 'コード',
  'columns': 'カラム',
  'compare': '比較',
  'compass': 'コンパス',
  'compliance': 'コンプライアンス',
  'configure': '構成',
  'connect': '接続',
  'contact-info': '連絡先情報',
  'contact': '連絡先',
  'contract': '契約',
  'copy': 'コピー',
  'credit-card': 'クレジットカード',
  'cube': '立方体',
  'cubes': '立方体',
  'currency': '通貨',
  'cursor': 'カーソル',
  'cut': '切り取り',
  'cycle': 'サイクル',
  'dashboard': 'ダッシュボード',
  'database': 'データベース',
  'deliver': '提供',
  'deploy': 'デプロイ',
  'descend': '下降',
  'desktop': 'デスクトップ',
  'detach': 'デタッチ',
  'diamond': 'ダイヤモンド',
  'directions': '方向',
  'dislike': '賛同しない',
  'document-cloud': 'ドキュメントクラウド',
  'document-config': 'ドキュメント設定',
  'document-csv': 'ドキュメントCSV',
  'document-download': 'ドキュメントのダウンロード',
  'document-excel': 'ドキュメントExcel',
  'document-exe': 'ドキュメント実行',
  'document-image': 'ドキュメント画像',
  'document-locked': 'ドキュメントロック済み',
  'document-missing': 'ドキュメント欠落',
  'document-notes': 'ドキュメントメモ',
  'document-outlook': 'ドキュメントOutlook',
  'document-pdf': 'ドキュメントPDF',
  'document-performance': 'ドキュメントパフォーマンス',
  'document-ppt': 'ドキュメントPPT',
  'document-rtf': 'ドキュメントRTF',
  'document-sound': 'ドキュメントサウンド',
  'document-store': 'ドキュメント保存',
  'document-test': 'ドキュメントテスト',
  'document-threat': 'ドキュメント脅威',
  'document-time': 'ドキュメント時刻',
  'document-transfer': 'ドキュメント転送',
  'document-txt': 'ドキュメントtxt',
  'document-update': 'ドキュメント更新',
  'document-upload': 'ドキュメントアップロード',
  'document-user': 'ドキュメントユーザー',
  'document-verified': 'ドキュメント検証済み',
  'document-video': 'ドキュメントビデオ',
  'document-windows': 'ドキュメントWindows',
  'document-word': 'ドキュメントWord',
  'document-zip': 'ドキュメントZIP',
  'document': 'ドキュメント',
  'domain': 'ドメイン',
  'down': '下へ',
  'download': 'ダウンロード',
  'drag': 'ドラッグ',
  'drive-cage': 'ドライブケージ',
  'duplicate': '重複',
  'edit': '編集',
  'eject': '取り出し',
  'empty-circle': '空の円',
  'expand': '拡大',
  'fan': 'ファン',
  'fast-forward': '早送り',
  'favorite': 'お気に入り',
  'filter': 'フィルター',
  'finger-print': '指紋',
  'flag': 'フラグ',
  'folder-cycle': 'フォルダーサイクル',
  'folder-open': 'フォルダー開く',
  'folder': 'フォルダー',
  'forward-ten': '10進む',
  'gallery': 'ギャラリー',
  'gamepad': 'ゲームパッド',
  'gift': 'ギフト',
  'globe': '地球',
  'grid': 'グリッド',
  'group': 'グループ',
  'grow': '拡張',
  'halt': '停止',
  'help': 'ヘルプ',
  'history': '履歴',
  'home': 'ホーム',
  'host-maintenance': 'ホストメンテナンス',
  'host': 'ホスト',
  'image': 'イメージ',
  'impact': '影響',
  'in-progress': '進行中',
  'inbox': '受信トレイ',
  'indicator': 'インジケーター',
  'info': '情報',
  'inherit': '継承',
  'inspect': '検査',
  'install': 'インストール',
  'integration': '統合',
  'iteration': '反復',
  'java': 'Java',
  'language': '言語',
  'launch': '起動',
  'layer': 'レイヤー',
  'license': 'ライセンス',
  'like': '賛同する',
  'line-chart': '線グラフ',
  'link-bottom': 'リンク末尾',
  'link-down': 'リンク下へ',
  'link-next': 'リンク次へ',
  'link-previous': 'リンク前へ',
  'link-top': 'リンクトップへ',
  'link-up': 'リンク上へ',
  'link': 'リンク',
  'local': 'ローカル',
  'location-pin': '場所ピン',
  'location': '場所',
  'lock': 'ロック',
  'login': 'ログイン',
  'logout': 'ログアウト',
  'magic': '魔法',
  'mail-option': 'メールオプション',
  'mail': 'メール',
  'manual': 'マニュアル',
  'map-location': 'マップ位置',
  'map': 'マップ',
  'menu': 'メニュー',
  'microphone': 'マイクロフォン',
  'money': 'お金',
  'monitor': 'モニター',
  'more': 'その他',
  'multiple': '複数',
  'navigate': 'ナビゲート',
  'new-window': '新規ウィンドウ',
  'new': '新規',
  'next': '次へ',
  'nodes': 'ノード',
  'note': 'メモ',
  'notes': 'メモ',
  'notification': '通知',
  'object-group': 'オブジェクトグループ',
  'object-ungroup': 'オブジェクトグループ解除',
  'optimize': '最適化',
  'organization': '組織',
  'overview': '概要',
  'pan': 'パン',
  'pause-fill': '一時停止中塗り',
  'pause': '一時停止',
  'personal-computer': 'パーソナルコンピューター',
  'pie-chart': '円グラフ',
  'pin': 'ピン',
  'plan': '計画',
  'platform-amazon': 'プラットフォームAmazon',
  'platform-android': 'プラットフォームAndroid',
  'platform-apple': 'プラットフォームApple',
  'platform-archlinux': 'プラットフォームArch Linux',
  'platform-aruba': 'プラットフォームAruba',
  'platform-centos': 'プラットフォームCentOS',
  'platform-chrome': 'プラットフォームChrome',
  'platform-cloudlinux': 'プラットフォームCloudLinux',
  'platform-debian': 'プラットフォームDebian',
  'platform-docker': 'プラットフォームDocker',
  'platform-dos': 'プラットフォームDOS',
  'platform-dropbox': 'プラットフォームDropbox',
  'platform-edge': 'プラットフォームEdge',
  'platform-fedora': 'プラットフォームFedora',
  'platform-firefox': 'プラットフォームFirefox',
  'platform-freebsd': 'プラットフォームFreeBSD',
  'platform-google': 'プラットフォームGoogle',
  'platform-hadoop': 'プラットフォームHadoop',
  'platform-heroku': 'プラットフォームHeroku',
  'platform-horton': 'プラットフォームHorton',
  'platform-hp': 'プラットフォームHP',
  'platform-hpi': 'プラットフォームHPI',
  'platform-internet-explorer': 'プラットフォームInternet Explorer',
  'platform-java': 'プラットフォームJava',
  'platform-mandriva': 'プラットフォームMandriva',
  'platform-mysql': 'プラットフォームMySQL',
  'platform-norton': 'プラットフォームNorton',
  'platform-onedrive': 'プラットフォームOneDrive',
  'platform-opera': 'プラットフォームOpera',
  'platform-oracle': 'プラットフォームOracle',
  'platform-pied-piper': 'プラットフォームPied Piper',
  'platform-raspberry': 'プラットフォームRaspberry',
  'platform-reactjs': 'プラットフォームReact.js',
  'platform-redhat': 'プラットフォームRed Hat',
  'platform-safari-option': 'プラットフォームSafariオプション',
  'platform-safari': 'プラットフォームSafari',
  'platform-sco': 'プラットフォームSCO',
  'platform-solaris': 'プラットフォームSolaris',
  'platform-suse': 'プラットフォームSUSE',
  'platform-swift': 'プラットフォームSwift',
  'platform-turbolinux': 'プラットフォームTurbolinux',
  'platform-ubuntu': 'プラットフォームUbuntu',
  'platform-unixware': 'プラットフォームUnixWare',
  'platform-vmware': 'プラットフォームVMware',
  'platform-windows-legacy': 'プラットフォームWindowsレガシー',
  'platform-windows': 'プラットフォームWindows',
  'play-fill': '再生中塗り',
  'play': '再生',
  'power': '電源',
  'previous': '前へ',
  'print': '印刷',
  'radial-selected': 'ラジアル選択',
  'radial': 'ラジアル',
  'refresh': '更新',
  'resources': 'リソース',
  'resume': '再開',
  'revert': '戻す',
  'rewind': '巻き戻し',
  'risk': 'リスク',
  'robot': 'ロボット',
  'rss': 'RSS',
  'run': '走る',
  'satellite': '衛星',
  'save': '保存',
  'scan': 'スキャン',
  'schedule-new': 'スケジュール新規',
  'schedule-play': 'スケジュール再生',
  'schedule': 'スケジュール',
  'schedules': 'スケジュール',
  'scorecard': 'スコアカード',
  'search-advanced': '詳細検索',
  'search': '検索',
  'secure': 'セキュア',
  'select': '選択',
  'selection': '選択',
  'send': '送信',
  'server-cluster': 'サーバークラスター',
  'server': 'サーバー',
  'servers': 'サーバー',
  'service-play': 'サービス再生',
  'services': 'サービス',
  'settings-option': '設定オプション',
  'share': '共有',
  'shield-security': 'シールドセキュリティ',
  'shield': 'シールド',
  'shift': 'シフト',
  'sidebar': 'サイドバー',
  'social-amazon': 'ソーシャルAmazon',
  'social-amex': 'ソーシャルAMEX',
  'social-bitcoin': 'ソーシャルBitcoin',
  'social-codepen': 'ソーシャルCodepen',
  'social-creative-commons': 'ソーシャルCreative Commons',
  'social-dropbox': 'ソーシャルDropbox',
  'social-facebook-option': 'ソーシャルFacebookオプション',
  'social-facebook': 'ソーシャルFacebook',
  'social-github': 'ソーシャルGithub',
  'social-google-plus': 'ソーシャルGoogle+',
  'social-google-wallet': 'ソーシャルGoogle Wallet',
  'social-instagram': 'ソーシャルInstagram',
  'social-linkedin-option': 'ソーシャルLinkedInオプション',
  'social-linkedin': 'ソーシャルLinkedIn',
  'social-mail': 'ソーシャルメール',
  'social-mastercard': 'ソーシャルMastercard',
  'social-medium': 'ソーシャルMedium',
  'social-paypal': 'ソーシャルPayPal',
  'social-pinterest': 'ソーシャルPinterest',
  'social-product-hunt': 'ソーシャルProduct Hunt',
  'social-reddit': 'ソーシャルReddit',
  'social-skype': 'ソーシャルSkype',
  'social-slack': 'ソーシャルSlack',
  'social-snapchat': 'ソーシャルSnapchat',
  'social-square': 'ソーシャルSquare',
  'social-stack-overflow': 'ソーシャルStack Overflow',
  'social-stripe': 'ソーシャルStripe',
  'social-tumblr': 'ソーシャルTumblr',
  'social-twitter': 'ソーシャルTwitter',
  'social-vimeo': 'ソーシャルVimeo',
  'social-vine': 'ソーシャルVine',
  'social-visa': 'ソーシャルVisa',
  'social-wordpress': 'ソーシャルWordPress',
  'social-youtube': 'ソーシャルYouTube',
  'sort': 'ソート',
  'split': '分割',
  'splits': '複数分割',
  'stakeholder': '関係者',
  'standards-3d-effects': '標準3Dエフェクト',
  'standards-connectivity': '標準コネクティビティ',
  'standards-css3': '標準CSS3',
  'standards-device': '標準デバイス',
  'standards-fireball': '標準ファイアボール',
  'standards-html5': '標準HTML5',
  'standards-multimedia': '標準マルチメディア',
  'standards-offline-storage': '標準オフラインストレージ',
  'standards-performance': '標準パフォーマンス',
  'standards-sematics': '標準セマンティクス',
  'star-half': '星半分',
  'star': '星',
  'steps': 'ステップ',
  'stop-fill': '停止中塗り',
  'stop': '停止',
  'storage': 'ストレージ',
  'street-view': 'ストリートビュー',
  'subtract-circle': '減算円',
  'subtract': '減算',
  'support': 'サポート',
  'sync': '同期',
  'system': 'システム',
  'table-add': 'テーブル追加',
  'table': 'テーブル',
  'tag': 'タグ',
  'target': 'ターゲット',
  'task': 'タスク',
  'tasks': 'タスク',
  'technology': 'テクノロジー',
  'template': 'テンプレート',
  'terminal': 'ターミナル',
  'test-desktop': 'テストデスクトップ',
  'test': 'テスト',
  'text-wrap': 'テキスト折り返し',
  'threats': '脅威',
  'ticket': 'チケット',
  'tools': 'ツール',
  'tooltip': 'ツールヒント',
  'top-corner': '上部コーナー',
  'transaction': 'トランザクション',
  'trash': 'ゴミ',
  'tree': '木',
  'trigger': 'トリガー',
  'trophy': 'トロフィー',
  'troubleshoot': 'トラブルシューティング',
  'unlink': 'リンク解除',
  'unlock': 'ロック解除',
  'up': '上へ',
  'update': '更新',
  'upgrade': 'アップグレード',
  'upload': 'アップロード',
  'user-add': 'ユーザー追加',
  'user-admin': 'ユーザー管理者',
  'user-expert': 'ユーザー専門家',
  'user-female': 'ユーザー女性',
  'user-manager': 'ユーザーマネージャー',
  'user-new': 'ユーザー新規',
  'user-police': 'ユーザー警察',
  'user-settings': 'ユーザー設定',
  'user-worker': 'ユーザー作業者',
  'user': 'ユーザー',
  'validate': '検証',
  'video': 'ビデオ',
  'view': '表示',
  'virtual-machine': '仮想マシン',
  'vm-maintenance': 'VMメンテナンス',
  'volume-low': 'ボリューム小',
  'volume-mute': 'ボリュームミュート',
  'volume': 'ボリューム',
  'vulnerability': '脆弱性',
  'waypoint': 'ウェイポイント',
  'workshop': 'ワークショップ',
  'zoom-in': 'ズームイン',
  'zoom-out': 'ズームアウト'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/grommet/messages/icons/ja-JP.js
// module id = 128
// module chunks = 0